import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TvProductionTrackerService } from 'src/app/services/tv-production-tracker.service';
import { GenericService } from 'src/app/services/generic.service';
import { ToastrService } from 'ngx-toastr';
import { videoURL } from 'src/app/services/base-url';

@Component({
  selector: 'app-editor-workflow',
  templateUrl: './editor-workflow.component.html',
  styleUrls: ['./editor-workflow.component.css']
})
export class EditorWorkflowComponent implements OnInit {

  statusMap: any = {
    'CREATED': 'Created',
    'EDITOR_ASSIGNED': 'Editor Assigned',
    'EDIT_COMPLETED': 'Edit Completed',
    'TITLE_ASSIGNED': 'Title Assigned',
    'TITLE_COMPLETED': 'Title Completed',
    'GRAPHICS_ASSIGNED': 'Graphics Assigned',
    'GRAPHICS_COMPLETED': 'Graphics Completed',
    'SEO_ASSIGNED': 'SEO Assigned',
    'SEO_COMPLETED': 'SEO Completed',
    'QUALITY_CHECK_ASSIGNED': 'Quality Check Assigned',
    'QUALITY_CHECK_COMPLETED': 'Quality Check Completed',
    'PUBLISHING_ASSIGNED': 'Publishing Assigned',
    'PUBLISHING_COMPLETED': 'Publishing Completed',
    'COMPLETED': 'Completed',
    'PENDING': 'Pending',
    'EPISODE_CREATION': 'Episode Creation'
  };

  episodeList: any = [];
  pageNumber: number = 1;
  totalRecords: number = 0;
  first: number = 0;
  tableSize: number = 10;
  isLoading: boolean = false;
  searchFilter: string = "";

  selectedEpisode: any = null;
  editorForm: any | FormGroup;
  formSubmit: boolean = false;
  cid: any;
  loggedInUserId: any;

  userList: any[] = [];
  graphicsUserList: any[] = [];
  selectedUserIdToAssign: any = "";
  videoUrl: any = videoURL
  userType: any;

  constructor(
    private tvProductionTrackerService: TvProductionTrackerService,
    private genericService: GenericService,
    private toastr: ToastrService,
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {
    this.cid = Number(sessionStorage.getItem('cid'));
    this.loggedInUserId = Number(sessionStorage.getItem('userId')) || 0;
    this.initForm();
    this.userType = sessionStorage.getItem("userType");
    if (this.userType.toLowerCase() === "admin" || this.userType.toLowerCase() === "bo" || this.userType.toLowerCase() === "boadmin") {
      this.getAllEpisodes();
    } else {
      this.getAllTvProductionTrackersUserId();
    }
    this.getAllUsers();
  }

  getAllEpisodes() {
    this.isLoading = true;
    this.tvProductionTrackerService.getAllEpisodes().subscribe(
      (res: any) => {
        if (res && res.response) {
          this.episodeList = res.response.filter((e: any) => e.currentStage === 'EDITOR');
          this.totalRecords = this.episodeList.length;
        } else {
          this.episodeList = [];
          this.totalRecords = 0;
        }
        this.isLoading = false;
      },
      (err: any) => {
        console.error(err);
        this.isLoading = false;
      }
    );
  }

  getAllUsers() {
    this.genericService.getUsersWithoutCustomers().subscribe(
      (res: any) => {
        if (res && res.response) {
          this.userList = res.response;
          this.graphicsUserList = this.userList.filter((u: any) => u.userType === 'GRAPHICS');
        }
      },
      (err: any) => {
        console.error(err);
      }
    );
  }

  initForm() {
    this.editorForm = this.fb.group({
      editorUser: [''],
      assignToEditorOnDate: [''],
      editStartDate: [''],
      editEndDate: [''],
      noOfDaysToEdit: [''],
      noOfHoursToEdit: [''],
      commonNotes: ['']
    });
  }

  getAllTvProductionTrackersUserId() {
    this.isLoading = true;
    this.tvProductionTrackerService.getAllTvProductionTrackersUserId(this.loggedInUserId).subscribe(
      (res: any) => {
        if (res && res.response) {
          this.episodeList = res.response;
          this.totalRecords = this.episodeList.length;
        } else {
          this.episodeList = [];
          this.totalRecords = 0;
        }
        this.isLoading = false;
      },
      (err: any) => {
        console.error(err);
        this.isLoading = false;
      }
    );
  }

  onTableDataChange(event: any) {
    this.pageNumber = event.page + 1;
  }

  refreshAll() {
    this.pageNumber = 1;
    this.first = 0;
    this.searchFilter = "";
    if (this.userType.toLowerCase() === "admin" || this.userType.toLowerCase() === "bo" || this.userType.toLowerCase() === "boadmin") {
      this.getAllEpisodes();
    } else {
      this.getAllTvProductionTrackersUserId();
    }
  }

  openEditorModal(episode: any) {
    this.selectedEpisode = episode;
    this.editorForm.patchValue({
      ...episode,
      commonNotes: ''
    });
    this.formSubmit = false;
    this.selectedUserIdToAssign = "";
  }

  closeModal() {
    document.getElementById("closeEditorModalBtn")?.click();
    this.selectedEpisode = null;
    this.editorForm.reset();
    this.selectedUserIdToAssign = "";
  }

  saveDetails(complete: boolean) {
    if (this.editorForm.invalid) {
      this.formSubmit = true;
      this.toastr.error("Please fill required fields");
      return;
    }

    let commonNotesArr = this.selectedEpisode.commonNotes || [];
    if (this.editorForm.get('commonNotes').value) {
      commonNotesArr.push({
        userId: Number(sessionStorage.getItem('userId')) || 0,
        userName: sessionStorage.getItem('userName') || '',
        commonNotes: this.editorForm.get('commonNotes').value,
        date: new Date().getTime()
      });
    }

    let nextStage = this.selectedEpisode.currentStage;
    if (complete && this.selectedUserIdToAssign) {
      nextStage = "GRAPHICS";
    }

    let finalEditEndDate = this.editorForm.get('editEndDate').value ? new Date(this.editorForm.get('editEndDate').value).getTime() : 0;
    let finalNoOfDays = this.editorForm.get('noOfDaysToEdit').value || 0;
    let finalNoOfHours = this.editorForm.get('noOfHoursToEdit').value || 0;
    let finalEditStartDate = this.editorForm.get('editStartDate').value ? new Date(this.editorForm.get('editStartDate').value).getTime() : this.selectedEpisode.editStartDate;

    if (complete) {
      finalEditEndDate = new Date().getTime();
      if (finalEditStartDate) {
        const diffMs = finalEditEndDate - finalEditStartDate;
        finalNoOfDays = Math.max(0, Math.floor(diffMs / (1000 * 60 * 60 * 24)));
        finalNoOfHours = Math.max(0, Math.floor(diffMs / (1000 * 60 * 60)));
      }
    }

    const payload: any = {
      ...this.selectedEpisode,
      commonNotes: commonNotesArr,
      editorUser: this.editorForm.get('editorUser').value,
      assignToEditorOnDate: this.editorForm.get('assignToEditorOnDate').value ? new Date(this.editorForm.get('assignToEditorOnDate').value).getTime() : (this.selectedEpisode.assignToEditorOnDate || 0),
      editStartDate: finalEditStartDate || 0,
      editEndDate: finalEditEndDate,
      noOfDaysToEdit: finalNoOfDays,
      noOfHoursToEdit: finalNoOfHours,
      episodeStatus: complete ? 'EDIT_COMPLETED' : this.selectedEpisode.episodeStatus,
      currentStage: nextStage,
      graphicsUser: (complete && this.selectedUserIdToAssign) ? this.selectedUserIdToAssign : this.selectedEpisode.graphicsUser,
      assignedUserId: (complete && this.selectedUserIdToAssign) ? Number(this.userList.find((item: any) => item.userName === this.selectedUserIdToAssign)?.userId || 0) : (this.selectedEpisode.assignedUserId || 0),
      assignToGraphicsTeamOnDate: (complete && this.selectedUserIdToAssign) ? new Date().getTime() : this.selectedEpisode.assignToGraphicsTeamOnDate,
      graphicsCreationStartDate: (complete && this.selectedUserIdToAssign) ? new Date().getTime() : this.selectedEpisode.graphicsCreationStartDate,
      graphicsDueDate: (complete && this.selectedUserIdToAssign) ? new Date().getTime() + (2 * 24 * 60 * 60 * 1000) : this.selectedEpisode.graphicsDueDate,
      cid: this.cid
    };
    delete payload.episodeNotes;
    delete payload.editorNotes;
    delete payload.titleNotes;
    delete payload.graphicsNotes;
    delete payload.seoNotes;
    delete payload.qualityCheckNotes;
    delete payload.publishingNotes;

    this.tvProductionTrackerService.updateEpisodeWorkflow(payload).subscribe(
      (res: any) => {
        this.toastr.success(res.message || 'Workflow updated successfully');
        if (this.userType.toLowerCase() === "admin" || this.userType.toLowerCase() === "bo" || this.userType.toLowerCase() === "boadmin") {
          this.getAllEpisodes();
        } else {
          this.getAllTvProductionTrackersUserId();
        }
        this.closeModal();
      },
      (err: any) => {
        this.toastr.error(err?.error?.errors?.[0]?.description || 'Error updating workflow');
      }
    );
  }

  isMyNote(note: any): boolean {
    if (!note || note.userId === undefined || note.userId === null) return false;
    return Number(note.userId) === Number(this.loggedInUserId);
  }

  sendChat() {
    const noteText = this.editorForm.get('commonNotes')?.value;
    if (!noteText) {
      return;
    }

    const payload = {
      userId: Number(sessionStorage.getItem('userId')) || 0,
      userName: sessionStorage.getItem('userName') || '',
      commonNotes: noteText,
      date: new Date().getTime()
    };

    this.tvProductionTrackerService.updateCommonNotes(this.selectedEpisode.tvProductionTrackerId, payload).subscribe(
      (res: any) => {
        let commonNotesArr = this.selectedEpisode.commonNotes || [];
        commonNotesArr.push(payload);
        this.selectedEpisode.commonNotes = commonNotesArr;
        this.editorForm.patchValue({ commonNotes: '' });
      },
      (err: any) => {
        this.toastr.error('Error sending chat');
      }
    );
  }
}
